import React from 'react';
import Header from './Header';
import Footer from './Footer';
import { Outlet, useLocation } from 'react-router-dom';
import { UserProvider } from '../utils/UserContext';

const Main = () => {
    const location = useLocation();
    const isBiAgent = location.pathname === '/bi-agent';

    return (
        <div className="flex min-h-screen flex-col">
            <UserProvider>
                <Header />
                <main
                    className={
                        isBiAgent
                            ? 'flex-1 w-full'
                            : 'flex-1 w-full mx-auto max-w-layout box-border p-2 sm:p-3'
                    }
                >
                    <Outlet />
                </main>
            </UserProvider>
            <Footer />
        </div>
    );
};

export default Main;
